export const OPEN_TABLE_TRANSLATION_KEY = 'page.cms.content.openTable'

export const COLLAPSE_TABLE_TRANSLATION_KEY = 'page.cms.content.hideTable'
